import { createClient } from '@supabase/supabase-js'

// Get environment variables from runtime configuration
const getEnvVar = (key: string): string => {
  // Check if we're in production (window.ENV exists)
  if (typeof window !== 'undefined' && (window as any).ENV) {
    return (window as any).ENV[key] || ''
  }
  // Development fallback
  return import.meta.env[key] || ''
}

const supabaseUrl = getEnvVar('VITE_SUPABASE_URL') || 'https://ebuvrdivowcjqfkhxsnj.supabase.co'
const supabaseKey = getEnvVar('VITE_SUPABASE_KEY')

export const supabase = createClient(supabaseUrl, supabaseKey)

// Database types for Modern Artillery webstore
export interface Database {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          full_name: string | null
          avatar_url: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          email: string
          full_name?: string | null
          avatar_url?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          email?: string
          full_name?: string | null
          avatar_url?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      products: {
        Row: {
          id: string
          product_code: string
          name: string
          description: string | null
          base_price: number
          category: string
          in_stock: boolean
          stock_quantity: number | null
          image_url: string | null
          is_active: boolean
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          product_code: string
          name: string
          description?: string | null
          base_price: number
          category: string
          in_stock?: boolean
          stock_quantity?: number | null
          image_url?: string | null
          is_active?: boolean
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          product_code?: string
          name?: string
          description?: string | null
          base_price?: number
          category?: string
          in_stock?: boolean
          stock_quantity?: number | null
          image_url?: string | null
          is_active?: boolean
          created_at?: string
          updated_at?: string
        }
      }
      product_options: {
        Row: {
          id: string
          product_id: string
          option_type: 'finish' | 'optic_cut' | 'barrel' | 'recoil_spring'
          option_name: string
          price_modifier: number
          in_stock: boolean
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          product_id: string
          option_type: 'finish' | 'optic_cut' | 'barrel' | 'recoil_spring'
          option_name: string
          price_modifier?: number
          in_stock?: boolean
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          product_id?: string
          option_type?: 'finish' | 'optic_cut' | 'barrel' | 'recoil_spring'
          option_name?: string
          price_modifier?: number
          in_stock?: boolean
          created_at?: string
          updated_at?: string
        }
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      [_ in never]: never
    }
    Enums: {
      [_ in never]: never
    }
  }
}
